import { useListToolbarButton, useListToolbarButtonState } from '@platejs/list-classic/react';
import { List, ListOrdered } from 'lucide-react';
import { KEYS } from 'platejs';
import { ToolbarButton } from './toolbar';

const nodeTypeMap: Record<string, { icon: React.JSX.Element; label: string }> = {
  [KEYS.olClassic]: { icon: <ListOrdered />, label: 'Numbered List' },
  [KEYS.ulClassic]: { icon: <List />, label: 'Bulleted List' },
};

export function ListToolbarButton({
  nodeType = KEYS.ulClassic,
  ...props
}: React.ComponentProps<typeof ToolbarButton> & {
  nodeType?: string;
}) {
  const state = useListToolbarButtonState({ nodeType });
  const { props: buttonProps } = useListToolbarButton(state);
  const { icon, label } = nodeTypeMap[nodeType] ?? nodeTypeMap[KEYS.ulClassic];

  return (
    <ToolbarButton {...props} {...buttonProps} tooltip={label}>
      {icon}
    </ToolbarButton>
  );
}
